module.exports = __webpack_public_path__ + "img/founder.238d1e44.png";